import { apiFetch } from "./apiClient";

export async function getCustomerById(customerId) {
  /* console.log(`🏢 [Frontend] Getting customer by ID: ${customerId}`);
  console.log(
    `🏢 [Frontend] Making API call to /api/services/service/customer/${customerId}`,
  ); */

  try {
    const res = await apiFetch(`/api/services/service/customer/${customerId}`);
    //console.log(`🏢 [Frontend] API response status: ${res.status}`);
    //console.log(`🏢 [Frontend] API response ok: ${res.ok}`);

    if (!res.ok) {
      //console.error(`❌ [Frontend] API call failed with status ${res.status}`);
      throw new Error("Failed to fetch customer details");
    }

    const data = await res.json();
    //console.log(`✅ [Frontend] Customer data received:`, {
    //  exists: data.exists,
    //  hasCustomer: !!data.customer,
    //  customerName: data.customer?.customer?.uk_name || "unknown",
    //});
    //console.log(`🏢 [Frontend] Full response structure:`, data);

    return data;
  } catch (error) {
    console.error(`❌ [Frontend] Error getting customer ${customerId}:`, error);
    throw error;
  }
}

export async function getCustomerByName(customerName) {
  const res = await apiFetch(
    `/api/services/service/customer/name/${customerName}`,
  );
  if (!res) {
    throw new Error("Failed to fetch customer details");
  }
  const data = await res.json();
  if (res.ok) {
    if (data.exists) {
      // customer exists
      return { exists: true, customer: data.customer };
    } else {
      // not an error — customer not found
      return { exists: false, customer: null };
    }
  } else {
    throw new Error(data.error || "Unknown API error");
  }
}

export async function getCustomers() {
  const res = await apiFetch(`/api/services/service/customers`);
  if (!res.ok) {
    throw new Error("Failed to fetch customers");
  }
  return res.json();
}

// To be used for Customer and Technician role to get their own customer details without needing to know their customer ID
export async function getMyCustomer() {
  const res = await apiFetch(`/api/services/service/my-customer`);
  if (!res.ok) {
    throw new Error("Failed to fetch my customer");
  }
  return res.json();
}

export async function createCustomer(customerData) {
  const res = await apiFetch(`/api/services/service/create-customer`, {
    method: "POST",
    body: JSON.stringify(customerData),
  });
  if (!res.ok) {
    const errorData = await res
      .json()
      .catch(() => ({ error: "Unknown error" }));
    console.error("Create customer error:", errorData);
    throw new Error(
      `Failed to create customer: ${errorData.error || errorData.details || "Unknown error"}`,
    );
  }
  return res.json();
}

export async function updateCustomer(customerId, customerData) {
  const res = await apiFetch(`/api/services/service/customer/${customerId}`, {
    method: "POST",
    body: JSON.stringify(customerData),
  });
  if (!res.ok) {
    throw new Error("Failed to update customer");
  }
  return res.json();
}
